module.exports = __webpack_public_path__ + "static/about-e34522697a97f825db06374345ce90a0.svg";